import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { PdpSharedBlurbDesignYourOwn_item$key } from './__generated__/PdpSharedBlurbDesignYourOwn_item.graphql';

// components
import StoneCutRadiant from 'dibs-icons/exports/StoneCutRadiant';
import { PdpSharedBlurb } from './PdpSharedBlurb/PdpSharedBlurb';

// helpers
import { dyoDetail, dyoTitle } from '../messages/pdpBlurbMessages';

type Props = {
    item: PdpSharedBlurbDesignYourOwn_item$key;
};

export const PdpSharedBlurbDesignYourOwn: FC<Props> = ({ item: itemRef }) => {
    const item = useFragment(
        graphql`
            fragment PdpSharedBlurbDesignYourOwn_item on Item {
                isDyoCustomizable
            }
        `,
        itemRef
    );

    const showDyoVersion = item.isDyoCustomizable;

    if (!showDyoVersion) {
        return null;
    }

    return <PdpSharedBlurb IconComponent={StoneCutRadiant} title={dyoTitle} detail={dyoDetail} />;
};
